import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';

import { cn } from 'utils/cn';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverArrow = PopoverPrimitive.Arrow;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    portal?: boolean;
    container?: HTMLElement | ShadowRoot | null;
  }
>(
  (
    { className, align = 'center', sideOffset = 4, portal = false, container = document.body, ...props },
    ref
  ) => {
    const Component = (
      <PopoverPrimitive.Content
        data-atarim={true}
        // hideWhenDetached
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'origin-[var(--radix-popover-content-transform-origin)]',
          'font-roboto text-textcolor data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border border-border bg-background p-4 shadow-md outline-none',
          className
        )}
        {...props}
      />
    );
    if (portal) {
      return <PopoverPrimitive.Portal container={container}>{Component}</PopoverPrimitive.Portal>;
    }

    return Component;
  }
);

PopoverContent.displayName = PopoverPrimitive.Content.displayName;

type PopoverComponentType = typeof Popover & {
  Content: typeof PopoverContent;
  Trigger: typeof PopoverTrigger;
  Arrow: typeof PopoverArrow;
};

const TypedPopover = Popover as PopoverComponentType;
TypedPopover.Content = PopoverContent;
TypedPopover.Trigger = PopoverTrigger;
TypedPopover.Arrow = PopoverArrow;

export default TypedPopover;
